const INCREMENT = 'INCREMENT';
const DECREMENT = 'DECREMENT';
const SET = 'SET';

function incrementCount() {
    return {
        type: INCREMENT,
    };
}

function decrementCount() {
    return {
        type: DECREMENT,
    };
}

function setCount(value: number) {
    return {
        type: SET,
        value
    }
}

export { INCREMENT, incrementCount, decrementCount, DECREMENT, setCount, SET };
